import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

import { getCookie } from "../../helpers/localStorage";
import {
  GET_ALL_BILLING_FREQUENCY,
  onToastError,
  onToastSuccess,
} from "../../helpers/utils";
import { useSelectedPackage } from "../../redux/hooks/hooks";
import Spinner from "../spinner/Spinner";
import { useMutation, useQuery } from "@apollo/client";
import { ADD_SUBSCRIPTION } from "../../pages/signup/utils";
import { partnerLoginId } from "../../redux/constants";
import { FaCar } from "react-icons/fa";
// Champ texte personnalisé
const Input = React.forwardRef(
  ({ label, icon, error, placeholder, ...props }, ref) => (
    <div className="flex items-center justify-between mb-4 ">
      <label className="w-60 mb-1 font-medium text-gray-700">{label}</label>
      <div className="flex-1">
        <div className="flex-1 relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`w-full pl-10 pr-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
              error
                ? "border-red-500 focus:ring-red-500"
                : "focus:ring-blue-500"
            }`}
            placeholder={placeholder}
            {...props}
          />
        </div>
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    </div>
  )
);

export const Select = React.forwardRef(
  ({ label, icon, error, placeholder, children, ...props }, ref) => (
    <div className="flex items-center justify-between mb-4">
      <label className="w-60 mb-1 font-medium text-gray-700">{label}</label>
      <div className="flex-1">
        <div className="flex-1 relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
              {icon}
            </div>
          )}
          <select
            ref={ref}
            className={`w-full pl-10 pr-3 py-2 border rounded-md focus:outline-none focus:ring-2 ${
              error
                ? "border-red-500 focus:ring-red-500"
                : "focus:ring-blue-500"
            }`}
            {...props}
          >
            <option value={""}>{placeholder}</option>
            {children}
          </select>
        </div>
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>
    </div>
  )
);
const schema = z.object({
  productType: z.coerce
    .number({
      invalid_type_error: "Product type is required",
    })
    .refine((val) => val > 0, {
      message: "You must select a valid product type",
    }),
  billingFrequencyId: z.coerce
    .number({
      invalid_type_error: "Billing frequency is required",
    })
    .refine((val) => val > 0, {
      message: "You must select a valid billing frequency",
    }),
  salesRemarks: z.string().min(1, { message: "Sale remark is required" }),
  deviceTrackingCharges: z.number(),
  deviceModelId: z.number(),
  deviceQuantity: z.number(),
  hardwareCharges: z.number(),
  partnerLoginId: z.number(),
  GST: z.number(),
  clientLoginId: z.number(),
  softwareQuantity: z.number(),
  accessoryQuantity: z.number(),
  accessoryCharges: z.number(),
  simQuantity: z.number(),
  simCharges: z.number(),
  startDate: z.string().min(1, { message: "Start date is required" }),
  endDate: z.string().min(1, { message: "End date is required" }),
});

const FormSubscription = ({ loadingPlans, errorPlans, plans }) => {
  const intl = useIntl();
  const onSelectProduct = useSelectedPackage();
  const [loader, setLoader] = useState(false);
  const {
    loading,
    error,
    data: frequency,
  } = useQuery(GET_ALL_BILLING_FREQUENCY);
  const [addSubcripstion, { loading: mutating }] =
    useMutation(ADD_SUBSCRIPTION);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      productType: getCookie("onSelectProduct") || onSelectProduct || "choice",
      billingFrequencyId: "choice",
      salesRemarks: "",
      deviceTrackingCharges: 200,
      deviceModelId: 28,
      deviceQuantity: 2000,
      hardwareCharges: 200,
      GST: 18,
      softwareQuantity: 2000,
      partnerLoginId: partnerLoginId,
      accessoryQuantity: 2000,
      accessoryCharges: 200,
      simQuantity: 2000,
      simCharges: 200,
      clientLoginId: getCookie("userId") ? parseInt(getCookie("userId")) : 1117,
    },
  });
  useEffect(() => {
    setValue(
      "productType",
      getCookie("onSelectProduct")
        ? getCookie("onSelectProduct")
        : onSelectProduct
        ? onSelectProduct
        : "choice"
    );
  }, [onSelectProduct]);
  console.log(watch("productType"), parseInt(getCookie("userId")));

  const onSubmit = async (data) => {
    console.log("Validated data:", data);
    await onCreateSubscription(data);
  };
  const onCreateSubscription = async (formData) => {
    console.log("Validated error:");

    try {
      const { data, error } = await addSubcripstion({
        variables: {
          clientLoginId: formData.clientLoginId,
          partnerLoginId: formData.partnerLoginId,
          billingFrequencyId: formData.billingFrequencyId,
          GST: formData.GST,
          softwareQuantity: formData.softwareQuantity,
          deviceTrackingCharges: formData.deviceTrackingCharges,
          deviceModelId: formData.deviceModelId,
          deviceQuantity: formData.deviceQuantity,
          hardwareCharges: formData.hardwareCharges,
          salesRemarks: formData.salesRemarks,
          accessoryQuantity: formData.accessoryQuantity,
          accessoryCharges: formData.accessoryCharges,
          simQuantity: formData.simQuantity,
          simCharges: formData.simCharges,
        },
      });

      console.log("Validated error:", error);

      if (error) {
        console.log("Validated error:", error);

        onToastError(error.message);
        return;
      }
      console.log("Résultat mutation:", data);

      if (data?.addSubscriptionsCustom) {
        onToastSuccess("Souscription créée avec succès");
        reset();
        console.log("Inscription réussie:", data.addSubscriptionsCustom);
      } else {
        console.error(
          "La mutation n'a pas retourné les données attendues:",
          data
        );
      }
    } catch (err) {
      if (err) {
        onToastError(
          err?.message ?? "une erreur s'est produite lors de l'inscription"
        );
        return;
      }
      console.error("Erreur d'inscription:", err);
    }
  };
  return (
    <form
      className="shadow-sm rounded-md space-y-6 bg-white px-4 lg:px-8 py-8"
      onSubmit={handleSubmit(onSubmit)}
    >
      {/* productType */}
      <Select
        label="Type de produit"
        icon={<FaCar />}
        placeholder={intl.formatMessage({ id: "make.your.choice" })}
        {...register("productType")}
        error={errors.productType?.message}
      >
        {plans?.getAllPlans?.map((item, index) => (
          <option key={index} value={item.id}>
            {item.planName}
          </option>
        ))}
      </Select>
      <Select
        label="Billing Frequency"
        icon={<FaCar />}
        placeholder={intl.formatMessage({ id: "make.your.choice" })}
        {...register("billingFrequencyId")}
        error={errors.billingFrequencyId?.message}
      >
        {frequency?.getAllBillingFrequency?.map((item, index) => (
          <option key={index} value={item.id}>
            {item.frequency}
          </option>
        ))}
      </Select>

      <Input
        label="Date de début"
        type="date"
        icon={<FaCar />}
        placeholder="Ex : AB-123-CD"
        {...register("startDate")}
        error={errors.startDate?.message}
      />
      <Input
        label="Date de fin"
        type="date"
        icon={<FaCar />}
        placeholder="Ex : AB-123-CD"
        {...register("endDate")}
        error={errors.endDate?.message}
      />

      {/* salesRemarks */}
      <Input
        label="Sale Remarque*"
        icon={<FaCar />}
        placeholder="Sale Remarque"
        {...register("salesRemarks")}
        error={errors.salesRemarks?.message}
      />

      <div className="md:flex md:justify-end gap-4 items-center">
        <button
          type="submit"
          className={`inline-flex justify-center py-3 px-8 border border-transparent shadow-sm font-medium rounded-md text-white bg-light hover:bg-hover-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-light ${
            loader ? "disabled:opacity-50" : ""
          }`}
          disabled={mutating}
        >
          {mutating ? (
            <div className="flex items-center">
              <Spinner />
              {intl.formatMessage({ id: "sending" })}
            </div>
          ) : (
            <FormattedMessage id="send" defaultMessage="Send" />
          )}
        </button>
      </div>
    </form>
  );
};

export default FormSubscription;
